export default "/images/Device_pegada.png?f1d7c40c49ea833e50d1565d9921ea7b";